/** 创建订单时的 success_url 持久化（支付回跳跨 tab 读取） */

export const PAYMENT_SUCCESS_URL_STORAGE_KEY = 'lip_payment_success_url'

const SUCCESS_URL_TTL_MS = 24 * 60 * 60 * 1000

/** @param {string} routePath */
export function buildPaymentSuccessUrl(routePath, productId) {
  const path = String(routePath || '/').split('?')[0] || '/'
  const params = new URLSearchParams()
  if (productId) params.set('product_id', String(productId))
  params.set('status', 'success')
  return `${path}?${params.toString()}`
}

export function persistPaymentSuccessUrl(successUrl) {
  if (!import.meta.client || !successUrl) return
  try {
    localStorage.setItem(
      PAYMENT_SUCCESS_URL_STORAGE_KEY,
      JSON.stringify({ successUrl: String(successUrl), savedAt: Date.now() }),
    )
  } catch {
    /* ignore */
  }
}

export function readPaymentSuccessUrl() {
  if (!import.meta.client) return null
  try {
    const raw = localStorage.getItem(PAYMENT_SUCCESS_URL_STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    const age = Date.now() - Number(data?.savedAt || 0)
    if (!data?.successUrl || age > SUCCESS_URL_TTL_MS) {
      localStorage.removeItem(PAYMENT_SUCCESS_URL_STORAGE_KEY)
      return null
    }
    return String(data.successUrl)
  } catch {
    return null
  }
}

export function clearPaymentSuccessUrl() {
  if (!import.meta.client) return
  try {
    localStorage.removeItem(PAYMENT_SUCCESS_URL_STORAGE_KEY)
  } catch {
    /* ignore */
  }
}

/** pathname 以 /pricing 结尾视为价格页支付（兼容 i18n 前缀） */
export function isPricingPagePath(path) {
  const normalized = String(path || '').replace(/\/+$/, '') || '/'
  return /\/pricing$/.test(normalized)
}

export function hasPaymentCallbackQuery(route) {
  const status = String(route?.query?.status ?? '').toLowerCase()
  return status === 'success'
    || !!route?.query?.sessionId
    || !!route?.query?.session_id
    || !!route?.query?.product_id
}
